import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import the Quill styles
import "./index.css";
import ImageResize from "quill-image-resize";

ReactQuill.Quill.register("modules/imageResize", ImageResize);

// Add custom font
const Font = ReactQuill.Quill.import("formats/font");
Font.whitelist = ["PangeaAfrikanTrial"];
ReactQuill.Quill.register(Font, true);

const QuillEditor = ({ value, onChange }) => {
  console.log(value);

  // Custom color palette
  const customColors = [
    // Your Custom Colors

    "#ff0000",
    "#5D6B7F",
    "#00ff00",
    "#0000ff",
    "#ffa500",
    "#800080",
    "#008080",
    "#475569",
    "#2B2B2B",
    "#505A71",

    // Primary Colors and Variations
    "#FFFFFF",
    "#000000",
    "#FFFF00",
    "#0000FF",
    "#008000",
    "#FFA500",
    "#800080", // White, Black, Yellow, Blue, Green, Orange, Purple

    // Light Variations
    "#F8F9FA",
    "#D3D3D3",
    "#FFFACD",
    "#ADD8E6",
    "#90EE90",
    "#FFDAB9",
    "#E6E6FA", // Light Gray, Lemon Chiffon, Light Blue, Light Green, Peach, Lavender

    // Medium Variations
    "#A9A9A9",
    "#FFE135",
    "#6495ED",
    "#32CD32",
    "#FFB347",
    "#9370DB", // Dark Gray, Banana Yellow, Cornflower Blue, Lime Green, Mango, Medium Purple

    // Dark Variations
    "#5C5C5C",
    "#FFD700",
    "#1E90FF",
    "#006400",
    "#FF8C00",
    "#4B0082", // Dim Gray, Gold, Dodger Blue, Dark Green, Dark Orange, Indigo

    // Additional Vibrant Colors
    "#FFD700",
    "#DAA520",
    "#FF4500",
    "#DC143C",
    "#8B0000",
    "#2E8B57",
    "#4682B4",
    "#6A5ACD", // Gold, Golden Rod, Orange Red, Crimson, Dark Red, Sea Green, Steel Blue, Slate Blue

    // Cool Neutrals
    "#708090",
    "#778899",
    "#B0C4DE",
    "#696969", // Slate Gray, Light Slate Gray, Light Steel Blue, Dark Slate Gray

    // Muted Pastels
    "#E0FFFF",
    "#F5DEB3",
    "#FFB6C1",
    "#D8BFD8",
    "#FFDFD3", // Light Cyan, Wheat, Light Pink, Thistle, Light Peach

    // Brighter Vibrant Colors
    "#219EBC",
    "#FFAA33",
    "#FF6F61",
    "#6A994E",
    "#264653",
    "#E76F51", // Aqua Blue, Bright Orange, Salmon, Olive Green, Dark Teal, Rust Red
  ];

  return (
    <div>
      <ReactQuill
        value={value}
        onChange={onChange}
        theme="snow"
        placeholder="Write something awesome..."
        modules={{
          toolbar: [
            [{ header: "1" }, { header: "2" }],
            [{ size: [] }],
            ["bold", "italic", "underline", "strike"],
            [{ align: [] }],
            [
              { color: customColors }, // Add custom colors
              { background: customColors }, // Add custom background colors
            ],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "image", "code-block"],
            ["clean"],
          ],
          imageResize: {}, // Enable image resizing
        }}
        formats={[
          "header",
          "font",
          "size",
          "color",
          "background",
          "bold",
          "italic",
          "underline",
          "strike",
          "list",
          "bullet",
          "align",
          "link",
          "image",
          "code-block",
        ]}
      />
    </div>
  );
};

export default QuillEditor;
